import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getAllReaderHighlightsForContainerId,
  createNewHighlight,
  deleteHighlight,
} from './thunks';
import { HighlightsState } from './types';

export const name = 'highlights';

const initialState: HighlightsState = {
  selectedContentHighlights: [],
  selectedContentHighlightsStatus: 'idle',
  deleteHighlightStatus: 'idle',
};

export const getAllReaderHighlightsForContainerIdAsync = createAsyncThunk(
  name + '/ getAllReaderHighlightsForContainerId',
  getAllReaderHighlightsForContainerId
);
export const createNewHighlightAsync = createAsyncThunk(
  name + '/ createNewHighlight',
  createNewHighlight
);
export const deleteHighlightAsync = createAsyncThunk(
  name + '/ deleteHighlight',
  deleteHighlight
);
export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearDeleteHighlight: (state) => {
      state.deleteHighlightStatus = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllReaderHighlightsForContainerIdAsync.pending, (state) => {
        state.selectedContentHighlightsStatus = 'loading';
      })
      .addCase(
        getAllReaderHighlightsForContainerIdAsync.fulfilled,
        (state, action) => {
          state.selectedContentHighlightsStatus = 'idle';
          state.selectedContentHighlights = action.payload;
        }
      )
      .addCase(getAllReaderHighlightsForContainerIdAsync.rejected, (state) => {
        state.selectedContentHighlightsStatus = 'failed';
      })
      .addCase(deleteHighlightAsync.pending, (state) => {
        state.deleteHighlightStatus = 'loading';
      })
      .addCase(deleteHighlightAsync.fulfilled, (state) => {
        state.deleteHighlightStatus = 'success';
      })
      .addCase(deleteHighlightAsync.rejected, (state) => {
        state.deleteHighlightStatus = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
